import * as React from 'react';
import styled from 'styled-components';
import {useEffect, useRef} from 'react';

const StyledBackdrop = styled.div`
  position: fixed;
  z-index: 12;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
`;

interface IProps {
  onClick?: () => void;
}

const Backdrop: React.FC<IProps> = ({ onClick, children }) => {
  const backdropRef = useRef<HTMLDivElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (
      event.target === backdropRef.current
    ) {
      onClick?.();
    }
  };

  return (
    <StyledBackdrop ref={backdropRef} onClick={handleClick}>
      {children}
    </StyledBackdrop>
  );
};

export default Backdrop;
